import { inspect } from 'node:util';

const UNPRINTABLE_ERROR = '<unprintable error>';

export function stringifyError(error: unknown): string {
  try {
    if (error instanceof Error && typeof error.stack === 'string') {
      return error.stack;
    }
  } catch {
    // Fall back to inspecting the value when an Error-like object has a
    // throwing prototype or stack getter.
  }

  if (typeof error === 'string') {
    return error;
  }

  try {
    return inspect(error, {
      customInspect: false,
      getters: false,
      depth: 5,
    });
  } catch {
    return UNPRINTABLE_ERROR;
  }
}
